import React from 'react';
import ReactSelect from 'react-select';
import PropTypes from 'prop-types';

import DropdownIndicator from './DropdownIndicator';
import ClearIndicator from './ClearIndicator';
import MultiValueRemove from './MultiValueRemove';
import DropDownWrapper from './DropDownWrapper';

import identifier from '../identifier';

import './DropDown.css';

const autoGeneratedId = identifier();

const DropDown = React.forwardRef(({ label, id, ...props }, ref) => (
  <DropDownWrapper id={id} label={label}>
    <ReactSelect
      {...props}
      ref={ref}
      inputId={autoGeneratedId || id}
      className="DropDown__Container"
      classNamePrefix="DropDown"
      components={{ DropdownIndicator, ClearIndicator, MultiValueRemove }}
    />
  </DropDownWrapper>
));

export default DropDown;

DropDown.propTypes = {
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
